module.exports = __webpack_public_path__ + "img/e85a6c3.png";